import { createTheme, ThemeProvider } from "@mui/material";
import _Tooltip from "@mui/material/Tooltip";

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          padding: "10px 12px",
          backgroundColor: "rgba(47, 50, 56, 0.8)",
          borderRadius: 6,
        },
        arrow: {
          color: "rgba(47, 50, 56, 0.8)",
        },
      },
    },
  },
});

export const Tooltip = (props) => (
  <ThemeProvider theme={theme}>
    <_Tooltip {...props} />
  </ThemeProvider>
);
